import chartGenious from './assets/images/ChartGenious.png'
import crypSimulator from './assets/images/CrypSimulator.png'
import MyLegderPro from './assets/images/MyLedgerPro.png'
import Avanceon from './assets/images/Avanceon.png'
import TDC from './assets/images/Tdc.png'

const header = {
  homepage: '',
  title: 'AQ.',
}

const about = {
  name: 'Ali Qumail',
  role: 'Software Engineer',
  description:
  "I'm a Full Stack Software Engineer with 2.5+ years of hands-on experience building enterprise-grade IoT applications. I work at a leading industrial automation company that's driving $70M–$80M in business across the Middle East and South Asia.",
  resume: 'https://example.com',
  social: {
    linkedin: 'https://www.linkedin.com/in/ali-qumail-330b4334a/',
    github: 'https://github.com/aliqumail',
    medium: 'https://aliqumail.medium.com/'
  },
}

const experience = [
  {
    logo: Avanceon,
    designation: 'Software Engineer',
    company: 'Octopus Digital / Avanceon MEA',
    dates: 'Apr 2023 – Present',
    description: [
      'Contributing to a large-scale enterprise IoT platform using <b>Angular</b> and <b>.NET 6.</b>',
      'Implemented secure role-based access control using Microsoft Identity and refresh tokens.',
      'Developed RESTful APIs to process over <b>100, 000</b> IoT tags, optimizing storage and data handling in <b>SQL</b> Server.',
      'Enabled real-time features such as access control using <b>SignalR</b> for seamless client updates.',
      'Refactored shared components, reducing module codebase by <b>40%</b>.',
      'Deployed and maintained backend services on <b>Azure App Service</b> for scalability and reliability.',
      'Designed and optimized relational database schemas and performed complex queries for performance tuning.',
      'Created detailed technical design docs with <b>sequence diagrams</b>, <b>flowcharts</b>, and <b>UML</b> for effective collaboration.',
      'Delivered technical walkthroughs and <b>presentations</b> to stakeholders, including C-level executives and QA teams.',
      'Guided junior engineers in debugging, knowledge sharing, and effective task decomposition.'
    ]
  },
   {
    logo: TDC,
    designation: 'Backend Developer Intern',
    company: 'The Dev Corporate',
    dates: 'Aug 2022 - Oct 2022',
    description: [
      'Built RESTful APIs for a Time Tracking app using <b>Nest.js</b> and <b>MongoDB</b>.',
      'Deployed services on Heroku, using <b>Git/GitLab</b> for version control.', 
    ]
  }
]

const projects = [
  {
    name: 'CrypSimulator',
    description:
      'Virtual Cryptocurrency Trading Platform Built using a Microservice Architecture.',
    stack: ['React', '.NET Core', 'RabbitMQ', 'Docker'],
    sourceCode: 'https://github.com/AliQumail/CrypSimulator',
    livePreview: 'https://github.com/AliQumail/CrypSimulator',
    image: crypSimulator
  },
  {
    name: 'MyLedgerPro',
    description:
      'Web based ledger application written in Angular and .Net Core',
    stack: ['Angular', '.NET Core', 'SQL'],
    sourceCode: 'https://github.com/AliQumail/MyLedgerPro',
    livePreview: 'https://github.com/AliQumail/MyLedgerPro',
    image: MyLegderPro
  },
  {
    name: 'ChartGenious',
    description:
      "Let's you find insights about your data",
    stack: ['Angular'],
    sourceCode: 'https://github.com/AliQumail/ChartGenious',
    livePreview: 'https://github.com/AliQumail/ChartGenious',
    image: chartGenious
  },
]

const skills = [
  'Typescript',
  'Angular',
  'React',
  'C#',
  '.NET Core',
  'Azure',
  'Node JS',
  'SQL',
  'MongoDB',
  'RabbitMQ',
  'Signal R',
  'Microservices'
]

const contact = {
  email: 'aliqumail8@gmail.com',
}

export { header, about, experience, projects, skills, contact }
